export { ContactsTypeComponent } from './contacts-type/contacts-type.component';
export { ContactsValueFileComponent } from './contacts-value-file/contacts-value-file.component';
export { ContactsValueTextComponent } from './contacts-value-text/contacts-value-text.component';
export { ContactsValueTextareaComponent } from './contacts-value-textarea/contacts-value-textarea.component';
export { ContactsSortOrderComponent } from './contacts-sort-order/contacts-sort-order.component';
export { ContactsNameComponent } from './contacts-name/contacts-name.component';
export { ContactsViewOldComponent } from './contacts-view-old/contacts-view-old.component';
